var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.documentsToDisplay.length > 0)?_c('div',[_c('SectionTitle',{attrs:{"title":_vm.roleLabel}}),_vm._l((_vm.documentsToDisplay),function(document){return _c('div',{key:document.name},[_c('DocumentDisplayItem',{attrs:{"document":document}})],1)})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }